import classNames from "classnames";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Privacy } from "./docs/privacy";
import { Refund } from "./docs/refund";
import { Service } from "./docs/service";
import { Terms } from "./docs/terms";

type Policies =
  | "Terms of Use"
  | "Privacy Policy"
  | "Refund Policy"
  | "Service Agreement";

const DOC_SLUGS: Record<Policies, string> = {
  "Terms of Use": "terms-of-use",
  "Privacy Policy": "privacy-policy",
  "Refund Policy": "refund-policy",
  "Service Agreement": "service-agreement",
};

const DOC_TABS: Policies[] = [
  "Terms of Use",
  "Privacy Policy",
  "Refund Policy",
  "Service Agreement",
];

export const LegalPage = ({
  className = "",
  navbarHeight = 0,
}: {
  className?: string;
  navbarHeight?: number;
}) => {
  const [tab, setTab] = useState<Policies>("Terms of Use");

  const { doc } = useParams<{ doc: string }>();

  const navigate = useNavigate();

  useEffect(() => {
    switch (doc ?? "terms-of-use") {
      case "terms-of-use":
        setTab("Terms of Use");
        break;
      case "privacy-policy":
        setTab("Privacy Policy");
        break;
      case "refund-policy":
        setTab("Refund Policy");
        break;
      case "service-agreement":
        setTab("Service Agreement");
        break;
      default:
        setTab("Terms of Use");
        break;
    }
  }, [doc]);

  return (
    <div
      className={classNames(
        "border-b border-grey-200 bg-[#F4F7FA] py-[48px] md:py-[100px]",
        className,
      )}
    >
      <div className="flex flex-col gap-[32px] md:flex-row md:items-start md:gap-[64px]">
        <div
          className="hide-scroll-bar flex shrink-0 items-start gap-[8px] overflow-x-auto md:sticky md:w-fit md:flex-col md:overflow-visible"
          style={{ top: navbarHeight + 24 }}
        >
          {DOC_TABS.map((title) => (
            <button
              key={title}
              type="button"
              onClick={() => navigate(`/legal/${DOC_SLUGS[title]}`)}
              className={classNames(
                "shrink-0 whitespace-nowrap rounded-[200px] px-[12px] py-[8px] text-left font-onest text-[18px] tracking-[-0.36px] text-grey-800 transition-colors",
                { "bg-white": tab === title },
              )}
            >
              {title}
            </button>
          ))}
        </div>

        <div className="flex w-full flex-col gap-[48px] md:max-w-[693px] md:gap-[64px]">
          <div className="flex flex-col gap-[16px] text-ink">
            <h1 className="font-dela text-[32px] leading-[38px] tracking-[-0.64px] md:text-[48px] md:leading-[50px] md:tracking-[-0.96px]">
              {tab}
            </h1>
            <p className="font-onest text-[16px] tracking-[-0.32px] md:text-[20px] md:leading-[28px] md:tracking-[-0.4px]">
              Last updated on April 27, 2025
            </p>
          </div>

          <div className="flex flex-col gap-[64px]">
            {tab === "Privacy Policy" && <Privacy />}
            {tab === "Terms of Use" && <Terms />}
            {tab === "Refund Policy" && <Refund />}
            {tab === "Service Agreement" && <Service />}
          </div>
        </div>
      </div>
    </div>
  );
};
